@if (target(); as target) {
    <div
        class="mode-transition"
        role="status"
        aria-live="polite"
        animate.enter="transition-in"
        animate.leave="transition-out">
        <span class="orb" aria-hidden="true">
            <ra-icon [icon]="target === 'ai' ? 'magicpen' : 'edit'" varColor="contentInverse" [size]="26" />
        </span>

        <div class="texts">
            <ra-shiny-text class="title" [speed]="1.6">{{ titleKey() | translate }}</ra-shiny-text>
            <p class="subtitle">{{ subtitleKey() | translate }}</p>
        </div>

        <span class="bar" aria-hidden="true">
            <i [style.animation-duration.ms]="durationMs"></i>
        </span>

        <!-- Esqueleto do layout de DESTINO: o usuário já vê a forma do que vem. -->
        <div class="ghost" aria-hidden="true">
            @if (target === 'manual') {
                <div class="ghost-card ghost-sections">
                    <ra-skeleton width="50%" [height]="10" />
                    <ra-skeleton [height]="10" [count]="4" [gap]="10" />
                </div>
                <div class="ghost-card ghost-main">
                    <ra-skeleton width="40%" [height]="16" />
                    <ra-skeleton [height]="48" [count]="2" [gap]="10" [radius]="10" />
                    <ra-skeleton [height]="72" [radius]="10" />
                </div>
            } @else {
                <div class="ghost-card ghost-chat">
                    <div class="ghost-user-row"><ra-skeleton class="ghost-user" [height]="34" [radius]="14" /></div>
                    <ra-skeleton width="80%" [height]="10" />
                    <ra-skeleton width="60%" [height]="10" />
                    <ra-skeleton class="ghost-composer" [height]="40" [radius]="14" />
                </div>
            }

            <div class="ghost-card ghost-preview">
                <span class="ghost-sheet"></span>
            </div>
        </div>
    </div>
}
